/**
 * Created by i.lovenkov on 26.10.16.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp2;

var _reactRouter = require('react-router');

require('./Footer.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    FooterView: {
        displayName: 'FooterView'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/Footer/default/FooterView.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var FooterView = _wrapComponent('FooterView')((_temp2 = _class = function (_Component) {
    (0, _inherits3.default)(FooterView, _Component);

    function FooterView() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, FooterView);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FooterView.__proto__ || (0, _getPrototypeOf2.default)(FooterView)).call.apply(_ref, [this].concat(args))), _this), _this.renderBlock = function () {
            var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
            var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

            if (items.length > 0) {
                return _react3.default.createElement(
                    'div',
                    null,
                    _react3.default.createElement(
                        'p',
                        { className: 'main_nav_element' },
                        title
                    ),
                    items.map(function (page, index) {
                        return _react3.default.createElement(
                            'p',
                            { key: index },
                            _react3.default.createElement(
                                _reactRouter.Link,
                                { to: '/page/' + page.url },
                                page.title
                            )
                        );
                    })
                );
            }

            return null;
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(FooterView, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                _props$about = _props.about,
                about = _props$about === undefined ? [] : _props$about,
                _props$help = _props.help,
                help = _props$help === undefined ? [] : _props$help,
                _props$information = _props.information,
                information = _props$information === undefined ? [] : _props$information,
                phone = _props.phone,
                basementText = _props.basementText,
                lang = _props.lang;

            var footerText = '';

            if (basementText) {
                footerText = basementText.replace(/\r\n|\r|\n/g, '<br>');
            }

            return _react3.default.createElement(
                'div',
                { className: 'Footer' },
                _react3.default.createElement(
                    'footer',
                    { id: 'footer', className: 'Footer__content color-bg' },
                    _react3.default.createElement(
                        'div',
                        { className: 'copyright-bar' },
                        _react3.default.createElement(
                            'div',
                            { className: 'container' },
                            _react3.default.createElement(
                                'div',
                                { className: 'row footer-item' },
                                _react3.default.createElement(
                                    'div',
                                    { className: 'col-xs-6 col-sm-4 col-md-2 visible-xs' },
                                    _react3.default.createElement('div', { className: 'copyright', dangerouslySetInnerHTML: { __html: footerText } })
                                ),
                                _react3.default.createElement(
                                    'div',
                                    { className: 'col-xs-6 col-sm-4 col-md-2 visible-xs' },
                                    _react3.default.createElement(
                                        'p',
                                        { className: 'copyright_phone' },
                                        phone
                                    )
                                ),
                                _react3.default.createElement('div', { className: 'clearfix' }),
                                _react3.default.createElement(
                                    'div',
                                    { className: 'menu_items' },
                                    _react3.default.createElement(
                                        'div',
                                        { className: 'col-xs-12 col-sm-4 col-md-2 hidden-xs' },
                                        _react3.default.createElement('div', { className: 'copyright', dangerouslySetInnerHTML: { __html: footerText } }),
                                        _react3.default.createElement(
                                            'p',
                                            { className: 'copyright_phone' },
                                            phone
                                        )
                                    ),
                                    _react3.default.createElement(
                                        'div',
                                        { className: 'col-xs-6 col-sm-4 col-sm-offset-0 col-md-2 col-md-offset-1' },
                                        this.renderBlock(about, lang['store.footer.about_us'])
                                    ),
                                    _react3.default.createElement(
                                        'div',
                                        { className: 'col-xs-6 col-sm-4 col-md-2' },
                                        this.renderBlock(help, lang['store.footer.help'])
                                    ),
                                    _react3.default.createElement(
                                        'div',
                                        { className: 'col-xs-6 col-sm-4 col-md-2' },
                                        this.renderBlock(information, lang['store.footer.info'])
                                    ),
                                    _react3.default.createElement('div', { className: 'col-xs-6 col-sm-4 col-md-2' })
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);
    return FooterView;
}(_react2.Component), _class.propsType = {
    lang: _react2.PropTypes.object
}, _temp2));

exports.default = FooterView;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/default/FooterView.jsx
// module id = 1660
// module chunks = 0